import { CommonModule, NgClass } from '@angular/common';
import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faLock, faEnvelope, faUser,
  faBars
} from '@fortawesome/free-solid-svg-icons';
import { AppEnities, ExpiryStages } from '../common/constants.lib';

import _ from 'lodash';
import { LoggerService } from '../shared/logger.service';
import { AuthService } from '../auth/auth.service';
import { AuthTokenService } from '../auth/auth-token.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '../auth/me.lib';
import { TimeoutService } from '../auth/timeout.service';
import { IMenuItem, MenuItem } from '../common/obj.lib';
import { SocketService } from '../shared/socket.service';
import { SettingsService } from '../settings/settings.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule,
    // NgClass
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  faLock = faLock;

  menu: any[] = [];
  userMenu: any[] = []

  private _expiryTime = new BehaviorSubject<number>(this.timeoutService.expiresIn);
  get expiryTime() {
    return this._expiryTime.getValue();
  }
  set expiryTime(val: number) {
    this._expiryTime.next(val);
  }

  me: User | null = this.authTokenService.userComputed();

  refreshString: string | unknown = '';

  //#region Private

  private _subs: Subscription[] = [];

  private fullMenu = [
    MenuItem.create({ id: 0, title: "Home", url: "/home", entity: AppEnities.HOME }),
    MenuItem.create({ id: 1, title: "Edit License Agreement", url: "/admin-edit-policy", entity: AppEnities.LICENSE }),
    MenuItem.create({ id: 2, title: "Manage Enquiries", url: "/admin-enquires-list", entity: AppEnities.ENQUIRIES }),
    MenuItem.create({ id: 3, title: "Manage Help Information", url: "/admin-help-info", entity: AppEnities.HELP }),
    MenuItem.create({ id: 4, title: "Manage Disciplines", url: "/discipline-list", entity: AppEnities.DISCIPLINE }),
    MenuItem.create({ id: 5, title: "Manage Organisations", url: "/organisation-list", entity: AppEnities.ORGANISATIONS }),
    MenuItem.create({ id: 6, title: "Manage Evaluations", url: "/evaluation-list", entity: AppEnities.EVALUATION }),
    MenuItem.create({ id: 7, title: "Manage Company Parameters", url: "/controlparams", entity: AppEnities.CONTROL_PARAMS }),
    // MenuItem.create({ id: 8, title: "My User Details", url: "/user-profile" }),
    MenuItem.create({ id: 8, title: "Manage Placement Reviews", url: "/placement-review-list", entity: AppEnities.PLACEMENT_REVIEW }),
    MenuItem.create({ id: 9, title: "My Placement Reviews", url: "/my-placement-review-list", entity: AppEnities.MY_REVIEW }),
    MenuItem.create({ id: 10, title: "Research Data Export", url: "/research-data-export", entity: AppEnities.RESEARCH_DATA_EXPORT }),
  ];

  private userMenuCollection = [
    MenuItem.create({ id: 1, title: "Roles", url: "/roles", entity: AppEnities.ROLE }),
    MenuItem.create({ id: 2, title: "Users", url: "/users", entity: AppEnities.USER }),
    MenuItem.create({ id: 3, title: "My User Details", url: "/user-profile" }),
  ];
  //#endregion

  constructor(
    public authService: AuthService,
    public authTokenService: AuthTokenService,
    library: FaIconLibrary,
    private logger: LoggerService,
    public timeoutService: TimeoutService,
    public settings: SettingsService
  ) {
    library.addIcons(faLock, faEnvelope, faUser, faBars);
    effect(() => {
      this.logger.debug(`constructor:effect fired...`);
      this.buildMenu();
    });
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    // this.logger.debug(`ngOnInit...`);
    // this.me = this.authTokenService.userComputed();
    // this.buildMenu();
    // this.logger.debug('ngOnInit:me:', this.me);
    // this._subs.push(this.authTokenService.user$.subscribe(u => {
    //   this.me = u;
    //   this.buildMenu();
    // }));
    // this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
    //   this.logger.debug('status changed: **>> ', status);
    //   this.isLoggedIn = status;
    // }));
    // this._subs.push(this.timeoutService.expiresIn$.subscribe(togo => {
    //   this.logger.debug(`expires in `, togo);
    // }));
    // this.timeoutService.startCountdown();

    // this._subs.push(this.socketService.onRefresh()
    //   .subscribe((message: any | unknown) => {
    //     this.logger.debug(`onRefresh: `, message);
    //     this.refreshString = message;
    //   }));

  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
    this.timeoutService.stopCountdown();
  }

  //#endregion

  setClass(): string {
    if (this.timeoutService.expiryStage === ExpiryStages.Imminent) {
      return 'casi-imminent';
    } else if (this.timeoutService.expiryStage === ExpiryStages.Warning) {
      return 'casi-warning';
    } else if (this.timeoutService.expiryStage === ExpiryStages.Safe) {
      return 'casi-safe';
    } else {
      return 'casi-expired';
    }
  }

  signOut(): void {
    this.logger.debug('signOut...');

    this.authTokenService.removeToken();
    this.authService.logoutCall();

  };

  private buildMenu(): void {
    this.logger.debug('buildMenu:fullMenu', this.fullMenu);
    this.logger.debug('buildMenu:accessPermissions: ', this.authTokenService.accessComputed()); //.getAccessClaims());
    this.menu = _.sortBy(this.fullMenu, "title").filter(m => {
      return !(m as IMenuItem).entity || this.authTokenService.canIAccess(m.entity as string);
    });
    this.userMenu = _.sortBy(this.userMenuCollection, "id").filter(m => {
      return !(m as IMenuItem).entity || this.authTokenService.canIAccess(m.entity as string);
    });

    this.logger.debug('buildMenu:menu', this.menu);
    this.logger.debug('buildMenu:userMenu', this.userMenu);
  }

  // private buildMenu(): void {
  //   // this.logger.debug('buildMenu:fullMenu', this.fullMenu);
  //   // this.logger.debug('buildMenu:accessPermissions: ', this.authTokenService.getAccessClaims());
  //   this.menu = _.sortBy(this.fullMenu, "title").filter(m => {
  //     return true; // !(m as IMenuItem).entity;
  //   });

  // this.logger.debug('buildMenu:menu', this.menu);
  // }

}
